<template>
  <div>
    <TopNav />

    <div class="settings mtb15">
      <div class="container-fluid">
        <div class="row">
          <Menu />

          <div class="col-md-12 col-lg-9">
            <div class="tab-content" id="v-pills-tabContent">
              <div
                class="tab-pane fade show active"
                id="settings-profile"
                role="tabpanel"
                aria-labelledby="settings-profile-tab"
              >
                <div class="card">
                  <div class="card-body">
                    <h5 class="card-title">Bank</h5>

                    <div class="settings-profile" v-if="canAddBank">
                      <form @submit.prevent="submitForm">
                        <div
                          v-if="validationError"
                          class="alert alert-warning mt-3 mb-0"
                          role="alert"
                        >
                          {{ validationError }}
                        </div>
                        <div class="form-row mt-4">
                          <div class="col-md-12 mb-2">
                            <label for="formFirst">Nama Bank </label>
                            <select
                              v-model="selectedBank"
                              class="form-control w-100"
                              ref="selectElement"
                              :disabled="isSubmitting"
                            >
                              <option value="">Pilih Bank</option>
                              <option
                                v-for="item in banks"
                                :key="item.code"
                                :value="item.code"
                              >
                                {{ item.name }}
                              </option>
                            </select>
                          </div>
                          <div class="col-md-12 mb-2">
                            <label for="formLast">Nama Akun</label>
                            <input
                              style="color: #ffff"
                              id="formLast"
                              type="text"
                              class="form-control"
                              placeholder="Nama Akun"
                              v-model="formBank.ac_name"
                              :disabled="isSubmitting"
                            />
                          </div>
                          <div class="col-md-12 mb-2">
                            <label for="emailAddress">Nomor Akun</label>
                            <input
                              style="color: #ffff"
                              id="emailAddress"
                              type="text"
                              class="form-control"
                              placeholder="Nomor Akun"
                              v-model="formBank.ac_number"
                              :disabled="isSubmitting"
                            />
                          </div>

                          <div class="col-md-12 mt-4">
                            <button
                              class="btn btn-gradient"
                              type="submit"
                              :disabled="isSubmitting"
                            >
                              <span
                                v-if="isSubmitting"
                                class="spinner-border spinner-border-sm mr-2"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              <span>{{
                                isSubmitting
                                  ? "Memvalidasi rekening..."
                                  : "Tambahkan"
                              }}</span>
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>

                    <div
                      v-if="myBanks.length"
                      class="bank-account-list"
                      :class="{ 'mt-4': canAddBank }"
                    >
                      <div
                        v-for="item in myBanks"
                        :key="item.id"
                        class="bank-account-card"
                      >
                        <div class="bank-account-info">
                          <div class="bank-account-name">
                            {{ bankDisplayName(item) }}
                          </div>
                          <div class="bank-account-meta">
                            <span>Nama Akun: {{ item.ac_name }}</span>
                            <span
                              >Nomor Akun:
                              {{ maskLastDigits(item.ac_number) }}</span
                            >
                          </div>
                        </div>
                        <div class="bank-account-actions">
                          <button
                            type="button"
                            class="bank-account-action"
                            title="Edit"
                            @click="onEditBank(item)"
                          >
                            <i class="icon ion-md-create"></i>
                          </button>
                          <button
                            type="button"
                            class="bank-account-action bank-account-action-danger"
                            title="Hapus"
                            :disabled="deletingId === item.id"
                            @click="askDeleteBank(item)"
                          >
                            <i class="icon ion-md-trash"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer />

    <ModalEditBank
      v-model:show="showEditModal"
      :banks="banks"
      :bank="editingBank"
      :token="token"
      @updated="onEditUpdated"
      @close="closeEditModal"
    />

    <Transition name="modal">
      <div
        v-if="showDeleteModal"
        class="bank-delete-mask"
        @click.self="closeDeleteModal"
      >
        <div class="bank-delete-dialog">
          <div class="bank-delete-body text-center">
            <h5 class="bank-delete-title">Hapus Rekening</h5>
            <p class="bank-delete-text">
              Yakin ingin menghapus rekening
              <strong>{{ bankDisplayName(deletingBank) }}</strong>
              ({{ maskLastDigits(deletingBank?.ac_number) }})?
            </p>
            <div class="bank-delete-actions">
              <button
                type="button"
                class="btn btn-gradient"
                :disabled="!!deletingId"
                @click="confirmDeleteBank"
              >
                <span
                  v-if="deletingId"
                  class="spinner-border spinner-border-sm mr-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Hapus
              </button>
              <button
                type="button"
                class="btn btn-outline-light"
                :disabled="!!deletingId"
                @click="closeDeleteModal"
              >
                Batal
              </button>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script>
/* global $ */
// node_modules
import Cookies from "js-cookie";
import { useToast } from "vue-toastification";

// applibs
import themain from "@/applibs/themain.js";
import thestore from "@/applibs/thestore.js";

// json
// import banks from "../../banks/bank.json";

// components
import TopNav from "@/components/global/TopNav.vue";
import Footer from "@/components/global/Footer.vue";
import Menu from "@/components/Settings/Menu.vue";
import ModalEditBank from "@/components/modals/ModalEditBank.vue";

const toast = useToast();

export default {
  components: {
    TopNav,
    Footer,
    Menu,
    ModalEditBank,
  },
  data() {
    return {
      themain,
      banks: [],
      selectedBank: "",
      token: Cookies.get("jwt") || Cookies.get("usid"),
      usid: Cookies.get("usid"),
      user: {},
      myBanks: [],
      bankQuota: 3,
      formBank: {
        ac_name: "",
        ac_number: "",
      },
      isSubmitting: false,
      deletingId: null,
      validationError: "",
      showEditModal: false,
      editingBank: null,
      showDeleteModal: false,
      deletingBank: null,
    };
  },

  computed: {
    canAddBank() {
      return this.myBanks.length < this.bankQuota;
    },
  },

  watch: {
    canAddBank(val) {
      if (val) {
        this.$nextTick(() => this.handleSelect());
      } else {
        this.destroySelect();
      }
    },
  },

  async beforeMount() {
    var self = this;
    // cek expire token
    if (self.token) {
      var res = await thestore.postCheckToken(self.token);
      if (res.success == false) {
        Cookies.remove("jwt");
        Cookies.remove("usid");
        self.$router.go();
      }
    }
  },

  async mounted() {
    var self = this;

    // ambil data dia ketika login
    if (self.token != null && self.token != "") {
      var res = await thestore.getMyProfileData(self.token);
      self.user = res;
    } else {
      self.$router.push("/");
    }

    await self.getMyBank();
    await self.getBankList();

    if (self.canAddBank) {
      await self.$nextTick();
      self.handleSelect();
    }
  },

  beforeUnmount() {
    this.destroySelect();
  },

  methods: {
    // Sensor 6 digit terakhir untuk privasi nomor rekening
    maskLastDigits(value, digits = 6) {
      if (value == null || value === "") return "";
      const str = String(value);
      if (str.length <= digits) return "*".repeat(str.length);
      return str.slice(0, -digits) + "*".repeat(digits);
    },

    bankDisplayName(item) {
      const code = item?.name;
      const found = this.banks.find((bank) => bank.code === code);
      return found ? found.name : code || "-";
    },

    applyBankPayload(res) {
      if (Array.isArray(res?.banks)) {
        this.myBanks = res.banks;
      } else if (res?.data && Array.isArray(res.data.banks)) {
        this.myBanks = res.data.banks;
      } else if (res?.ac_number) {
        this.myBanks = [res];
      } else {
        this.myBanks = [];
      }

      if (res?.quota) {
        this.bankQuota = res.quota;
      } else if (res?.data?.quota) {
        this.bankQuota = res.data.quota;
      }
    },

    resetForm() {
      this.selectedBank = "";
      this.formBank = {
        ac_name: "",
        ac_number: "",
      };
      this.validationError = "";

      const el = this.$refs.selectElement;
      if (el) {
        const $el = $(el);
        if ($el.data("select2")) {
          $el.val("").trigger("change");
        }
      }
    },

    async submitForm() {
      var self = this;
      if (self.isSubmitting) return;

      self.validationError = "";

      if (!self.canAddBank) {
        self.validationError = "Maksimal 3 akun bank";
        toast.warning(self.validationError);
        return;
      }
      if (!self.selectedBank) {
        self.validationError = "Nama bank wajib dipilih";
        toast.warning(self.validationError);
        return;
      }
      if (!self.formBank.ac_name || !String(self.formBank.ac_name).trim()) {
        self.validationError = "Nama akun wajib diisi";
        toast.warning(self.validationError);
        return;
      }
      if (!self.formBank.ac_number || !String(self.formBank.ac_number).trim()) {
        self.validationError = "Nomor rekening wajib diisi";
        toast.warning(self.validationError);
        return;
      }

      self.isSubmitting = true;
      try {
        var res = await thestore.postMyBank(
          self.token,
          self.selectedBank,
          self.formBank.ac_name,
          self.formBank.ac_number
        );
        if (res.success == true) {
          self.applyBankPayload(res);
          self.resetForm();
          toast.success("Akun bank berhasil ditambahkan");
        } else {
          self.validationError =
            res.msg ||
            "Validasi rekening gagal. Silakan periksa data rekening Anda.";
          toast.warning(self.validationError);
        }
      } catch (error) {
        const apiMsg =
          error?.response?.data?.msg ||
          error?.response?.data?.message ||
          error?.message;
        self.validationError =
          apiMsg ||
          "Validasi rekening gagal: tidak dapat menghubungi server. Silakan coba lagi.";
        toast.warning(self.validationError);
      } finally {
        self.isSubmitting = false;
      }
    },

    onEditBank(item) {
      this.editingBank = item;
      this.showEditModal = true;
    },

    onEditUpdated(res) {
      this.applyBankPayload(res);
      this.closeEditModal();
    },

    closeEditModal() {
      this.showEditModal = false;
      this.editingBank = null;
    },

    askDeleteBank(item) {
      if (!item?.id || this.deletingId) return;
      this.deletingBank = item;
      this.showDeleteModal = true;
    },

    closeDeleteModal() {
      if (this.deletingId) return;
      this.showDeleteModal = false;
      this.deletingBank = null;
    },

    async confirmDeleteBank() {
      const item = this.deletingBank;
      if (!item?.id || this.deletingId) return;

      this.deletingId = item.id;
      try {
        const res = await thestore.deleteMyBank(this.token, item.id);
        if (res.success == true) {
          this.applyBankPayload(res);
          this.showDeleteModal = false;
          this.deletingBank = null;
          toast.success("Akun bank berhasil dihapus");
        } else {
          toast.warning(res.msg || "Gagal menghapus akun bank");
        }
      } catch (error) {
        const apiMsg =
          error?.response?.data?.msg ||
          error?.response?.data?.message ||
          error?.message;
        toast.warning(apiMsg || "Gagal menghapus akun bank");
      } finally {
        this.deletingId = null;
      }
    },

    async getMyBank() {
      var self = this;
      var res = await thestore.getMyBank(self.token);
      self.applyBankPayload(res);
    },

    async getBankList() {
      try {
        const res = await thestore.getBankList();
        const bankList = res?.data?.listsBank;

        if (Array.isArray(bankList)) {
          this.filterBank(bankList);
        } else {
          this.banks = [];
          toast.warning("Format daftar bank tidak valid");
        }
      } catch (error) {
        this.banks = [];
        toast.warning("Gagal memuat daftar bank");
      }
    },

    filterBank(banks) {
      this.banks = banks.filter((bank) => bank.can_disburse !== false);
    },

    destroySelect() {
      const el = this.$refs.selectElement;
      if (!el) return;

      const $el = $(el);
      if ($el.data("select2")) {
        $el.off("change");
        $el.select2("destroy");
      }
    },

    handleSelect() {
      const el = this.$refs.selectElement;
      if (!el) return;

      const $el = $(el);
      if ($el.data("select2")) {
        $el.select2("destroy");
      }

      $el.select2().on("change", (event) => {
        this.selectedBank = event.target.value;
      });
    },
  },
};
</script>

<style>
.select2-container--default .select2-selection--single {
  width: 100%;
  background-color: #2a2e39;
  border: none;
}
.select2-selection__rendered {
  color: rgb(141, 141, 141) !important;
}

.select2-dropdown {
  background-color: #2a2e39;
  color: aliceblue;
}
.select2-container--default
  .select2-results__option--highlighted[aria-selected],
.select2-container--default .select2-results__option[aria-selected="true"] {
  background-color: #4b4f5a;
}

.select2-search__field {
  background-color: #2a2e39;
  color: aliceblue;
  border: #4b4f5a;
}

.select2-container {
  width: 100% !important;
}

.btn-gradient:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.btn-gradient .spinner-border {
  vertical-align: text-bottom;
}

.bank-account-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.bank-account-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  background: #2a2e39;
  border-radius: 8px;
  padding: 16px 18px;
}

.bank-account-info {
  min-width: 0;
}

.bank-account-name {
  color: #ffffff;
  font-weight: 600;
  font-size: 15px;
  margin-bottom: 6px;
}

.bank-account-meta {
  display: flex;
  flex-direction: column;
  gap: 2px;
  color: #c5c8d0;
  font-size: 13px;
}

.bank-account-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.bank-account-action {
  background: transparent;
  border: none;
  color: #c5c8d0;
  font-size: 20px;
  line-height: 1;
  padding: 4px;
  cursor: pointer;
}

.bank-account-action:hover {
  color: #ffffff;
}

.bank-account-action-danger:hover {
  color: #ff6b6b;
}

.bank-account-action:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.bank-delete-mask {
  position: fixed;
  z-index: 10000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
}

.bank-delete-dialog {
  width: 100%;
  max-width: 420px;
  margin: 16px;
  padding: 28px 24px;
  background: linear-gradient(180deg, #1a1a2e 0%, #12121f 100%);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.45);
}

.bank-delete-title {
  color: #fff;
  font-weight: 600;
  margin-bottom: 12px;
}

.bank-delete-text {
  color: rgba(255, 255, 255, 0.78);
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 24px;
}

.bank-delete-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.bank-delete-actions .btn {
  width: 100%;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .bank-delete-dialog,
.modal-leave-to .bank-delete-dialog {
  transform: scale(0.96);
}
</style>
